import { mapActions } from 'vuex';

export default {
    name: 'DrawerUpdateMixin',
  
    methods: {

        ...mapActions('productsIaUpdate', ['saveTmpToUpdate']),
      
        onHandleUpdateProductWithIA(product) {
            this.saveTmpToUpdate({
                params: product,
                callback: this.callbackUpdateProductWithIA
            });
        },

        callbackUpdateProductWithIA(success, response) {
            this.$emit('update-temporary-product-with-ia', success, response);
        }

    },
};